import React from 'react';
import { useWatch } from 'react-hook-form';
import {
  minValue,
  NumberInput,
  ReferenceArrayInput,
  required,
  SelectInput,
  SelectArrayInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import { Grid, Typography } from '@mui/material';
import dueDiligenceDatesToTrack, { dueDiligenceDateToTrackChoices } from '../../../constants/dueDiligenceDatesToTrack';
import { unitsOfTimeChoices } from '../../../constants/unitsOfTime';
import resourceNames from '../../../constants/resourceNames';

const DueDiligence = () => {
  const {
    ruleParameters,
  } = useWatch();

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Grid container>
          <Grid size={12}>
            <Typography>Date to track</Typography>
          </Grid>
          <Grid size={12}>
            <SelectInput
              choices={dueDiligenceDateToTrackChoices}
              source="ruleParameters.dateToTrack"
              fullWidth
              validate={required()}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Grid container>
          <Grid size={12}>
            <Typography>Default threshold</Typography>
          </Grid>
          <Grid size={12}>
            <NumberInput
              fullWidth
              source="ruleParameters.defaultThreshold"
              validate={minValue(1)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Grid container>
          <Grid size={12}>
            <Typography>Unit of time</Typography>
          </Grid>
          <Grid size={12}>
            <SelectInput
              choices={unitsOfTimeChoices}
              source="ruleParameters.unitOfTime"
              fullWidth
              validate={required()}
            />
          </Grid>
        </Grid>
      </Grid>
      {ruleParameters
      && ruleParameters.dateToTrack === dueDiligenceDatesToTrack.LAST_FORM_SUBMITTED_DATE
          && (
            <Grid size={12}>
              <Grid container>
                <Grid size={12}>
                  <Typography>Forms to consider</Typography>
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <ReferenceArrayInput source="ruleParameters.formIds" reference="forms">
                    <SelectArrayInput optionText="title" />
                  </ReferenceArrayInput>
                </Grid>
              </Grid>
            </Grid>
          )}

      {ruleParameters
        && ruleParameters.dateToTrack === dueDiligenceDatesToTrack.GROUP_ASSIGNMENT
        && (
          <Grid size={12}>
            <Grid container>
              <Grid size={12}>
                <Typography>Group to consider</Typography>
              </Grid>

              <Grid size={12}>
                <ReferenceInput perPage={100} source="ruleParameters.groupToTrack" reference={resourceNames.GROUPS}>
                  <AutocompleteInput
                    label="Group"
                    filterSelectedOptions={false}
                    filterToQuery={(searchText) => ({ name: searchText })}
                    optionText={(item: {name: string}) => item.name}
                    helperText={false}
                    fullWidth
                  />
                </ReferenceInput>
              </Grid>
            </Grid>
          </Grid>
        )}
    </Grid>
  );
};

export default DueDiligence;
